import { render, staticRenderFns } from "./assignmentList.vue?vue&type=template&id=c20e5588"
import script from "../../controllers/assignment/assignment-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/assignment/assignment-list.js?vue&type=script&lang=js&external"
import style0 from "./assignmentList.vue?vue&type=style&index=0&id=c20e5588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports